module.exports = __webpack_public_path__ + "639f7c41f392d92cadca3d5017cae1de.svg";